<template>
  <div>
    <autocomplete-multiple :name="name" :search-text.sync="searchText" :items="items" :select.sync="localSelect" :loading="loadState.isLoading"  v-bind="typeof selectAllEnabled !== 'undefined' ? { selectAllEnabled } : {}">
      <template v-slot:itemInfo="{item}">
        <v-row no-gutters class="caption">
          <v-col v-if="item.user" cols="auto">{{ userTypeName(item.user.type) }}</v-col>
          <v-col v-if="item.user" cols="auto"><dot/></v-col>
          <v-col cols="auto">{{ $tools.dialogProviderName(item.provider) }}</v-col>
          <template v-if="item.user && item.user.userProfile">
            <v-col cols="auto"><dot/></v-col>
            <v-col cols="auto">{{ item.user.userProfile.gender === 'male' ? 'Мужчина' : 'Женщина' }}</v-col>
            <v-col v-if="!$tools.isEmpty(item.user.userProfile.birth)" cols="auto"><dot/></v-col>
            <v-col v-if="!$tools.isEmpty(item.user.userProfile.birth)" cols="auto">{{ $tools.dateYears(item.user.userProfile.birth, 'YYYY-MM-DD') }}</v-col>
          </template>
          <template v-if="!$tools.isEmpty(item.phone)">
            <v-col cols="auto"><dot/></v-col>
            <v-col cols="auto">{{ $tools.phoneFormat(item.phone) }}</v-col>
          </template>
        </v-row>
      </template>
      <template v-slot:appendOuter>
        <slot name="appendOuter"/>
      </template>
    </autocomplete-multiple>
  </div>

</template>

<script>
import State from "@/plugins/state";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import {Entity_DialogUser, Entity_User, Entity_UserProfile,} from "../../../EntityStoreCacheService";
import Dot from "@/componentsV2/base/Dot.vue";

export default {
  components: {AutocompleteMultiple, Dot},
  props: [
    'name',
    'select',
    '_type',
    '_provider',
    'selectAllEnabled'
  ],
  data: () => ({
    loadState: new State(),
    searchText: null,
    items: [],
    localSelect: null
  }),
  watch: {
    select() {
      this.localSelect = this.select;
      if (typeof this.localSelect !== 'undefined') {
        this.localSelect.forEach(v => {
          let found = false;
          this.items.forEach(v1 => {
            if (v.id === v1.id)
              found = true;
          })
          if (!found) {
            v.name = this.dialogUserName(v)
            this.items.push(v)
          }
        })
      }
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
      if (typeof this.localSelect !== 'undefined' && this.localSelect.length > 0 && this.items.length === 0) {
        this.localSelect.forEach(v => {
          v.name = this.dialogUserName(v)
          this.items.push(v)
        });
      }
    },
    searchText() {
      this.$tools.debounce(() => {
        this.load();
      });
    }
  },
  mounted() {
    this.localSelect = this.select;
    if (typeof this.localSelect !== 'undefined' && this.localSelect.length > 0) {
      let arr = [];
      this.localSelect.forEach(v => {
        v.name = this.dialogUserName(v)
        arr.push(v)
      });
      this.items = arr;
    }
  },
  methods: {
    dialogUserName(item) {
      if (!this.$tools.isEmpty(item.name))
        return item.name;
      if (item.user)
        return this.$tools.userFullName(item.user);
      return '';
    },
    userTypeName(type) {
      return type === 'admin' ? 'Администратор' : type === 'spec' ? 'Специалист' : 'Клиент';
    },
    load() {
      let rb = new Entity_DialogUser()
          .selects(Entity_DialogUser.id)
          .selects(Entity_DialogUser.name)
          .selects(Entity_DialogUser.phone)
          .selects(Entity_DialogUser.provider)
          .selects([Entity_DialogUser.user, Entity_User.id].join('.'))
          .selects([Entity_DialogUser.user, Entity_User.type].join('.'))
          .selects([Entity_DialogUser.user, Entity_User.lastName].join('.'))
          .selects([Entity_DialogUser.user, Entity_User.firstName].join('.'))
          .selects([Entity_DialogUser.user, Entity_User.secondName].join('.'))
          .selects([Entity_DialogUser.user, Entity_User.userProfile, Entity_UserProfile.birth].join('.'))
          .selects([Entity_DialogUser.user, Entity_User.userProfile, Entity_UserProfile.gender].join('.'))

      if (!this.$tools.isEmpty(this.searchText)) {
        let v = this.searchText.trim();
        if (/^\d+$/.test(v) && v.length > 0) {
          if (v.length >= 6) {
            rb.filterAnd(
                [Entity_DialogUser.entity, Entity_DialogUser.phone].join('.') + ' LIKE ? OR ' +
                [Entity_DialogUser.entity, Entity_DialogUser.id].join('.') + ' =?',
                '%' + v + '%',
                v
            )
          } else {
            rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.id].join('.') + ' =?', v)
          }
        } else if (/\d/.test(v)) {
          rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.phone].join('.') + ' LIKE ?', '%' + v.replace(/\D/g, '') + '%')
        } else {
          let arr = v.split(' ');
          if (arr.length === 1) {
            rb.filterOr([Entity_DialogUser.entity, Entity_DialogUser.name].join('.') + ' LIKE ?', '%' + arr[0] + '%')
            rb.filterOr([Entity_DialogUser.entity, Entity_DialogUser.user, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
          } else if (arr.length === 2) {
            rb.filterOr([Entity_DialogUser.entity, Entity_DialogUser.name].join('.') + ' LIKE ?', '%' + v + '%')
            rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.user, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.user, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
          } else if (arr.length === 3) {
            rb.filterOr([Entity_DialogUser.entity, Entity_DialogUser.name].join('.') + ' LIKE ?', '%' + v + '%')
            rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.user, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.user, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
            rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.user, Entity_User.secondName].join('.') + ' LIKE ?', arr[2] + '%')
          }
        }
      }

      if (this._provider !== undefined)
        rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.provider].join('.') + ' =?', this._provider)

      if (this._type !== undefined)
        rb.filterAnd([Entity_DialogUser.entity, Entity_DialogUser.user, Entity_User.type].join('.') + ' =?', this._type)

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })
          .page(null)
          .request((v) => {
            let newItems = v.items.map(item => ({
              ...item,
              name: this.dialogUserName(item)
            }));

            newItems = this.items.concat(newItems);
            newItems = this.$tools.sortByKey(newItems)
            this.items = this.$tools.uniqueByKey(newItems)

          }, (e) => {
            console.error(e.response.data.message);
          })
    },
  }
}
</script>
